function setTooltipClipboard() {
    const tooltiptext = document.querySelector(".tooltiptext");
    if(!tooltiptext) return;
    navigator.clipboard.writeText(window.location.href);
    tooltiptext.innerHTML = "URL Copied";
}

function resetTooltipClipboard() {
    const tooltiptext = document.querySelector(".tooltiptext");
    if(!tooltiptext) return;
    tooltiptext.innerHTML = "Copy URL";
}

const tooltip = document.querySelector('.tooltip');

if(tooltip) {
    tooltip.addEventListener('click', setTooltipClipboard);
    tooltip.addEventListener('mouseout', resetTooltipClipboard);
}
